import { useVerificationMethodContext } from "./verificationMethodContext";

export function useVerificationMethod() {
  const { verify, loading } = useVerificationMethodContext();
  return { verify, loading };
}
